import { Api } from '../../../utils/index.js';
export const baseEndpoint = `${Api.SHOPPER_GAM}/v1/sdu/`;
